import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const BorderWidthUnit = z.enum(["Pixels"]);

export const BorderWidthValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const BorderWidthTokenData = tokenAliasOrValue(BorderWidthValue);

export type BorderWidthUnit = z.infer<typeof BorderWidthUnit>;
export type BorderWidthValue = z.infer<typeof BorderWidthValue>;
export type BorderWidthTokenData = z.infer<typeof BorderWidthTokenData>;
